import { OpenTicketStatus, PlaceOrderStatus, PriceStyle } from '@/interface/enum';
import type { DynamicMarketOrderResponse, DynamicMarketTicketResponse } from '@/interface/pollux';

export interface IDynamicMarketTicket {
    uid: string;
    minBet: number;
    maxBet: number;
    balance: number | null;
    errorCode: OpenTicketStatus;
    selection: {
        price: { value: number, priceStyle: PriceStyle };
        betCondition: string;
        score: { home: number, away: number } | null;
    } | null;
}

export interface IDynamicMarketOrder {
    isPlaceBetSuccess: boolean;
    placeOrderStatus: PlaceOrderStatus;
    extraInfo: string;
}

export function formatDynamicMarketTicket(raw: DynamicMarketTicketResponse): IDynamicMarketTicket {
    return {
        uid: raw.uid,
        minBet: raw.minBet,
        maxBet: raw.maxBet,
        balance: raw.balance ?? null,
        errorCode: (raw.error?.code ?? OpenTicketStatus.Success) as OpenTicketStatus,
        selection: raw.selection
            ? {
                price: {
                    value: raw.selection.price?.value ?? 0,
                    priceStyle: raw.selection.price?.style === undefined
                        ? PriceStyle.Euro
                        : PriceStyle.fromPollux(raw.selection.price.style),
                },
                betCondition: raw.selection.betCondition ?? '',
                score: raw.selection.score
                    ? { home: raw.selection.score.home, away: raw.selection.score.away }
                    : null,
            }
            : null,
    };
}

export function formatDynamicMarketOrder(raw: DynamicMarketOrderResponse): IDynamicMarketOrder {
    return {
        isPlaceBetSuccess: raw.isPlaceBetSuccess,
        placeOrderStatus: PlaceOrderStatus.fromPollux(raw.placeOrderStatus),
        extraInfo: raw.extraInfo ?? '',
    };
}
